import { PureComponent } from "react";
import LaddaButton, { XL, ZOOM_IN } from "react-ladda";
import classnames from "classnames";
import {
  SPACE_BLUE_COLOR_NAME,
  WORK_OS_IRIS_COLOR_NAME,
  GRADIANT_WORKOS_IRIS_COLOR_NAME,
  BLACK_COLOR_NAME
} from "styles/color-consts";

import { componentStyles, colorsStyles, fontsStyles } from "./button-component.scss";
import laddaStyles from "./button-ladda-component.scss";

export const SUPPORTED_BUTTON_COLORS = [
  "blue",
  "outline-blue",
  "outline-dark-blue",
  "outline-dark-blue-inverted-hover",
  "outline-indigo-inverted-hover",
  "brand-blue",
  "brand-red",
  "brand-green",
  "brand-yellow",
  "brand-purple",
  "brand-iris",
  "green",
  "purple",
  "iris",
  "yellow",
  "royal",
  "orange",
  "dodger-blue",
  "white",
  "white-iris", // Temporary for Google connect support during button color test.
  "white-dodger", // Temporary for Google connect support during button color test.
  BLACK_COLOR_NAME,
  SPACE_BLUE_COLOR_NAME,
  WORK_OS_IRIS_COLOR_NAME,
  GRADIANT_WORKOS_IRIS_COLOR_NAME
];

const DEFAULT_COLOR = "dodger-blue";

export default class ButtonComponent extends PureComponent {
  getButtonColor() {
    const { color } = this.props;
    return SUPPORTED_BUTTON_COLORS.indexOf(color) !== -1 ? color : DEFAULT_COLOR;
  }

  render() {
    const {
      className,
      size,
      isLoading,
      onClickCallback,
      children,
      type,
      disabled,
      disableAnimation,
      dataSpinnerColor,
      invert,
      withBorder
    } = this.props;

    return (
      <LaddaButton
        className={classnames(`${className} ${this.getButtonColor()} ${size}`, {
          invert,
          "disable-animation": disableAnimation,
          "with-border": withBorder
        })}
        data-style={ZOOM_IN}
        data-size={XL}
        data-spinner-color={dataSpinnerColor}
        onClick={onClickCallback}
        type={type}
        loading={isLoading}
        disabled={disabled || isLoading}
      >
        {children}
        <style jsx>{componentStyles}</style>

        <style jsx>{colorsStyles}</style>

        <style jsx>{fontsStyles}</style>

        <style jsx>{laddaStyles}</style>
      </LaddaButton>
    );
  }
}

ButtonComponent.defaultProps = {
  isLoading: false,
  disableAnimation: false,
  onClickCallback: () => {},
  className: "",
  type: "button",
  withBorder: false
};
